<template>
    <v-dialog :fullscreen="!isDesktop" v-model="ratingDialog" @input="!ratingDialog ? $router.replace(`/${$route.params.username}`) : ''" max-width="500">
        <v-card :height="isDesktop ? '400px' : '100vh'">
            <v-btn icon absolute top right :to="`/${$route.params.username}`" replace exact>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-container fluid class="fill-height">
                <rating-widget :userDetails="{username: $route.params.username}"></rating-widget>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import ratingWidget from "@/components/widgets/widget-rating.vue"
export default {
    data() {
        return {
            ratingDialog: false
        }
    },

    mounted() {
        this.ratingDialog = true

    },

    components: {
        'rating-widget': ratingWidget
    }
}
</script>